<template>
	<div v-if="qnt != 0" class="content-os">
		<aside>
			<slot name="osNames" />
		</aside>
		<section :style="{ height: `${(qnt + 1) * 38}px` }">
			<div class="cnt-grafic" :style="cntGraficStyle">
				<div
					class="cnt-grid"
					:style="{ height: `${(qnt + 1) * 38}px` }"
				>
					<div
						v-if="meses != null"
						v-for="(daysQnt, mes) in meses"
						class="meses"
						:style="{ width: `${daysQnt * 24}px` }"
					>
						{{ translateDate(mes) }}
						<div
							class="month-separator"
							:style="{ height: `${qnt * 38 + 41}px` }"
						></div>
					</div>

					<div class="clearfix"></div>

					<div
						class="grid"
						:style="{ height: `${qnt * 38 + 24}px` }"
						v-for="itemGrid in (end.time - init.time) / 24"
					>
						<span class="day">
							{{ getDay(itemGrid).getDate() }}
						</span>
					</div>
				</div>
				<div class="cnt-grafic-os">
					<slot name="osTimeLine" />
				</div>

				<div
					class="currency"
					:style="{ height: `${qnt * 38 + 24}px`, left: `100px` }"
				></div>
			</div>
		</section>
	</div>
</template>
<script>
	import { timeNomalize } from './tools.js';

	export default {
		data() {
			return {
				meses: null,
				names: [
					'Janeiro',
					'Fevereiro',
					'Março',
					'Abril',
					'Maio',
					'Junho',
					'Julho',
					'Agosto',
					'Setembro',
					'Outubro',
					'Novembro',
					'Dezembro',
				],
			};
		},
		props: ['init', 'end', 'qnt'],
		methods: {
			translateDate(mes) {
				let d = mes.split('-');
				return `${this.names[d[1]]} de ${d[0]}`;
			},
			getDay(day) {
				let date = new Date(Date.parse(this.init.sDate));
				date.setHours(date.getHours() + day * 24);
				return date;
			},
			update() {
				let qnt = (this.end.time - this.init.time) / 24;
				const meses = {};
				for (let d = 1; d <= qnt; d++) {
					let xDate = this.getDay(d);
					xDate = `${xDate.getFullYear()}-${xDate.getMonth()}`;

					if (meses[xDate] == undefined) meses[xDate] = 1;
					else meses[xDate]++;
				}
				this.meses = meses;
			},
		},
		computed: {
			cntGraficStyle() {
				if (this.init.sDate == null) return {};

				return {
					width: `${this.end.time - this.init.time + 1}px`,
					height: `${(this.qnt + 1) * 38}px`,
				};
			},
		},
	};
</script>
<style scoped>
	.currency {
		position: absolute;
		background: red;
		width: 2px;
		top: 18px;
	}
	.meses:nth-child(2n) .month-separator {
		background: rgba(206, 206, 206, 0);
	}
	.month-separator {
		position: absolute;
		background: rgba(206, 206, 206, 0.16);
		width: 100%;
		top: 0px;
		left: 0px;
	}
	.meses {
		position: relative;
		float: left;
		color: #616161;
		font-size: 12px;
		text-transform: uppercase;
		text-align: center;
		border-right: 1px solid #cecece;
		border-bottom: 1px solid #cecece;
	}
	.grid .day {
		color: #989898;
		font-size: 10px;
	}
	.cnt-grid {
		border-top: 1px solid #cecece;
		border-left: 1px solid #cecece;
	}
	.grid {
		float: left;
		width: 24px;
		text-align: center;
		border-right: 1px solid #cecece;
		display: block;
	}
	.cnt-grafic-os {
		position: absolute;
		top: 41px;
		left: 0px;
		width: 100%;
		display: block;
	}
	.cnt-grafic {
		display: block;
		position: absolute;
		top: 0px;
		left: 0px;
	}

	.content-os {
		display: block;
		width: 100%;
		position: relative;
	}
	.content-os aside {
		padding-top: 41px;
		width: 25%;
		float: left;
		display: block;
		position: relative;
	}
	.content-os section {
		/*overflow: hidden;*/
		width: 75%;
		float: left;
		display: block;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/order-of-service/components/GraficMode/components/content-view.vue